import { useSelector } from "react-redux";
import ListTotal from "./ListTotal";

export default function ListTotalContainer() {
  const total = useSelector((state) => state.miljogebyrTilBehandling.total);
  return <ListTotal total={total} />;
}
